export const DINNERS: string[] = ["ribbe", "pinnekjøtt", "kalkun", "kylling", "gavekort"];

export const DINNER_LABELS: { [key: string]: string } = {
  gavekort: "gavekort (skriv gjerne hvor i boksen under)",
};
